// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knob-container {
    position: relative;
    width: 50px;
    height: 50px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.knob {
    position: absolute;
    width: 45px;
    height: 45px;
    background-color: #333;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #fff;
    transition: transform 0.1s ease-out;
}
.indicator {
    position: absolute;
    top: 0;
    width: 2px;
    height: 10%;
    background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/general_assets/controls.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":[".knob-container {\r\n    position: relative;\r\n    width: 50px;\r\n    height: 50px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.knob {\r\n    position: absolute;\r\n    width: 45px;\r\n    height: 45px;\r\n    background-color: #333;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: 2px solid #fff;\r\n    transition: transform 0.1s ease-out;\r\n}\r\n.indicator {\r\n    position: absolute;\r\n    top: 0;\r\n    width: 2px;\r\n    height: 10%;\r\n    background-color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
